import qs from 'qs';

export const serializeParams = (params: any) => {
  return qs.stringify(params, { arrayFormat: 'brackets' });
};
